import api from '../../api/api';
import toast from 'react-hot-toast';

// Actions
export const ACTION_ADMIN_SET_USERS = 'ACTION_ADMIN_SET_USERS';
export function setUsers(data) {
  return {
    type: ACTION_ADMIN_SET_USERS,
    payload: data,
  };
}

export const ACTION_ADMIN_SET_CONTRACTS = 'ACTION_ADMIN_SET_CONTRACTS';
export function setContracts(data) {
  return {
    type: ACTION_ADMIN_SET_CONTRACTS,
    payload: data,
  };
}

export const ACTION_ADMIN_SET_TOKENS = 'ACTION_ADMIN_SET_TOKENS';
export function setTokens(data) {
  return {
    type: ACTION_ADMIN_SET_TOKENS,
    payload: data,
  };
}

export const ACTION_ADMIN_SET_SELECTED_USER = 'ACTION_ADMIN_SET_SELECTED_USER';
export function setSelectedUser(data) {
  return {
    type: ACTION_ADMIN_SET_SELECTED_USER,
    payload: data,
  };
}

// Thunks
export function fetchUsersAsync() {
  return function (dispatch) {
    api.get('user').then(({ data }) => dispatch(setUsers(data)));
  };
}

export function fetchContractsAsync() {
  return function (dispatch) {
    api.get('contract').then(({ data }) => dispatch(setContracts(data)));
  };
}

export function fetchTokensAsync() {
  return function (dispatch) {
    api.get('token').then(({ data }) => dispatch(setTokens(data)));
  };
}

export const ACTION_ADMIN_UPDATE_USER = 'ACTION_ADMIN_UPDATE_USER';
export function saveUser(changes) {
  return function (dispatch) {
    if (changes._id) {
      api.put('user/' + changes._id, changes).then((resp) => {
        dispatch({
          type: ACTION_ADMIN_UPDATE_USER,
          payload: resp.data,
        });
      });
    }
  };
}

export const ACTION_CREATE_MASTER_CONTRACT = 'ACTION_CREATE_MASTER_CONTRACT';
export function saveMasterContract(dataContract) {
  return function (dispatch) {
    api.post('/contract/master/new', dataContract).then((resp) =>
      dispatch({
        type: ACTION_CREATE_MASTER_CONTRACT,
        payload: resp.data,
      })
    );
  };
}

export const ACTION_SET_MASTER_CONTRACTS = 'ACTION_SET_MASTER_CONTRACT';
export function setMasterContract() {
  return function (dispatch) {
    api.get('/contract/master/').then((resp) =>
      dispatch({
        type: ACTION_SET_MASTER_CONTRACTS,
        payload: resp.data,
      })
    );
  };
}
export const ACTION_UPDATE_MASTER_CONTRACT = 'ACTION_UPDATE_MASTER_CONTRACT';
export function addUserMasterContract(contractId, userId) {
  return function (dispatch) {
    api
      .patch(`/contract/master/userAdd/${contractId}`, { userId })
      .then((resp) =>
        dispatch({
          type: ACTION_UPDATE_MASTER_CONTRACT,
          payload: resp.data,
        })
      );
  };
}
export function setDeprecatedContract(contractId) {
  return function (dispatch) {
    api.patch(`/contract/master/deprecated/${contractId}`).then((resp) =>
      dispatch({
        type: ACTION_UPDATE_MASTER_CONTRACT,
        payload: resp.data,
      })
    );
  };
}
export function addMasterContractData(masterId, data) {
  return function (dispatch) {
    api.patch(`/contract/master/custom/${masterId}`, data).then((resp) =>
      dispatch({
        type: ACTION_UPDATE_MASTER_CONTRACT,
        payload: resp.data,
      })
    );
  };
}
export function addMasterContractCustomImage(masterId, file) {
  return function (dispatch) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      api
        .patch(`/contract/master/custom-image/${masterId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((resp) =>
          dispatch({
            type: ACTION_UPDATE_MASTER_CONTRACT,
            payload: resp.data,
          })
        );
      toast.success('Successfully upload!');
    } catch (error) {
      console.log(error);
      toast.error('Upload failed!');
    }
  };
}
